import React, { useEffect, useMemo, useState } from "react";
import VirtualTable from "../ui/VirtualTable";
import Cookies from "js-cookie";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { SortIcon } from "../utils/Icons";


export default function CustomerList(props) {

    const { controller = "", state = { view: "" }, data = [], setData = () => { }, selected = {}, setSelected = () => { }, loading = false, filters = {}, setFilters = () => { }, setLoading = () => { }, align = "auto", setAlign = () => { }, route = "" } = props;


    const min = (state?.view === "history") ? true : false;
    const row_key = "ship_to";
    const buffer = 20;


    const toggleSort = (_key) => {
        if (filters.sort === _key) {
            setFilters({ ...filters, "sort": "name", "dynamic": true })
        } else {
            setFilters({ ...filters, "sort": _key, "dynamic": true })
        }
    }


    const toggleLocalSort = (_key) => {

        let _f = "stock_id";
        if (data.length > 0 && data[0].hasOwnProperty("init")) {
            _f = "init";
        }

        if (filters.localSort === _key) {
            setFilters({ ...filters, "localSort": [_f], "dynamic": false })
        } else {
            setFilters({ ...filters, "localSort": _key, "dynamic": false })
        }

    }


    const colSort = (_text, _key, _local_key) => {

        if (!filters.dynamic) {
            const match = (filters.localSort === _key);
            if (!match) {
                return (<div onClick={() => toggleLocalSort(_local_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
            } else {
                return (<div onClick={() => toggleLocalSort(_local_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
            }
        }
        const match = (filters.sort === _key);
        if (!match) {
            return (<div onClick={() => toggleSort(_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div onClick={() => toggleSort(_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }


    const columns = [
        { min: true, key: "name", align: "left", title: colSort("Name", "name", "name"), width: 170, grow: true },
        { min: false, key: "email", align: "left", title: <>Email</>, width: 230, grow: true },
        { min: true, key: "phone", align: "left", title: <>Phone</>, width: 170, grow: false },
        { min: false, key: "enter_date", align: "left", title: <>Enter date</>, width: 110, grow: false },
        { min: false, key: "attention", align: "left", title: <>Attn</>, width: 170, grow: true },
    ]



    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };



    const fetch = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        let _filters = { ...filters };
        if (selected?.ship_to) {
            _filters.ship_to = selected.ship_to;
        } else {
            // Remember the customer
            if (Cookies.get("customer_ship_to")) {
                _filters.ship_to = Cookies.get("customer_ship_to");
            }
        }

        //_filters.ship_to = "122562";
        delete _filters.ship_to;
        pubCall("customer.getInitial", _filters, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const filteredFilters = useMemo(() => {
        const { dynamic, ...rest } = filters || {};
        return JSON.stringify(rest);
    }, [filters]);

    useEffect(fetch, [filteredFilters]);



    const fetchNext = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("customer.getNext", { ...filters, "limit": 20, "ship_to": data[data.length - 1]?.ship_to }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("customer.getPrevious", { ...filters, "limit": 20, "ship_to": data[0]?.ship_to }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }



    return (
        <>
            <VirtualTable
                controller={controller}
                onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                className={(state.view === "customers") ? "" : "desaturate"}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                next={next}
                prev={prev}
                align={align}
                row_key={row_key}
                current={selected}
                data={data}
                columns={(min) ? columns.filter(item => item.min) : columns}
                width={1100}
                loading={loading}
                offset={430}
                route={route}
            />
        </>
    )
}